/** @format */

import Cookies from "./../library/Cookies";
import Header from "./Header";

export default class Locale {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Locale();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		self.showHideLocaleSelectorBar();

		$(document).on("click", ".js-change-site", function (e) {
			e.preventDefault();
			self.changeSite();
		});

		$(document).on("click", ".js-on-click-flag-change-site", function (e) {
			e.preventDefault();
			self.changeSite($(this));
		});

		$(document).on("click", ".js-hide-locale-selector-bar", function (e) {
			e.preventDefault();
			Cookies.setCookie("locale-selector-bar", "shown", 1);
			self.showHideLocaleSelectorBar();
		});

		$(document).on("change", ".js-on-change-site-select", function () {
			self.changeSiteFromSelect($(this));
		});
	}

	showHideLocaleSelectorBar() {
		const self = this;

		const localeCookie = Cookies.getCookie("locale-selector-bar");

		if (localeCookie == "shown") {
			$(".js-locale-selector-bar").remove();
		} else {
			$("main").addClass("mod-has-locale-selector");
			$(".js-locale-selector-bar").show();
		}

		Header.refreshHeader();

		return this;
	}

	getSelectedSiteUrl($flag) {
		if (!$flag) {
			const $selectedOption = $(".js-locale-select").find("option:selected");
			return $selectedOption.attr("data-href") || $(".js-locale-select").val();
		}

		const siteCode = $flag.attr("data-code");
		const mappedSiteUrl = siteCode ? $(`.js-site-selector-url[data-code="${siteCode}"]`).attr("data-href") : null;

		return mappedSiteUrl || $flag.attr("data-href") || $flag.attr("href");
	}

	buildRedirectUrl(selectedSiteUrl) {
		if (!selectedSiteUrl) {
			return null;
		}

		try {
			const redirectUrl = new URL(selectedSiteUrl, window.location.origin);

			if (!redirectUrl.search) {
				redirectUrl.search = window.location.search;
			}

			if (!redirectUrl.hash) {
				redirectUrl.hash = window.location.hash;
			}

			return redirectUrl.toString();
		} catch (error) {
			return selectedSiteUrl;
		}
	}

	changeSite($flag) {
		const selectedSiteUrl = this.getSelectedSiteUrl($flag);
		const redirectUrl = this.buildRedirectUrl(selectedSiteUrl);

		if (!redirectUrl) {
			return;
		}

		$.oc.stripeLoadIndicator.show();

		Cookies.setCookie("locale-selector-bar", "shown", 60);
		window.location.href = redirectUrl;
	}

	changeSiteFromSelect($select) {
		const $selectedOption = $select.find("option:selected");
		const selectedSiteUrl = $selectedOption.attr("data-href") || $select.val();
		const redirectUrl = this.buildRedirectUrl(selectedSiteUrl);

		if (!redirectUrl) {
			return;
		}

		$.oc.stripeLoadIndicator.show();

		Cookies.setCookie("locale-selector-bar", "shown", 1);
		window.location.href = redirectUrl;
	}
}
